import React from "react";

interface CustomColumnsIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export function CustomColumnsIcon({ size = 24, color = "#3B4BD6", className }: CustomColumnsIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="6" height="16" rx="2" stroke={color} strokeWidth="2" fill="none" />
      <rect x="14" y="4" width="6" height="16" rx="2" fill={color} stroke={color} strokeWidth="2"/>
    </svg>
  );
} 